import { toBackendLang } from '@plone/volto/helpers/Utils/Utils';
import config from '@plone/volto/registry';
// import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry';
import { NavLink } from 'react-router-dom';
import { reviewStateClass } from '../reviewStateClass';

const SubItems = ({ item, lang, root, closeMenu = () => {} }) => {
  const { settings } = config;

  const content = item.items.map((child) => (
    <div key={child.url} className="l2">
      <NavLink
        to={child.url === '' ? '/' : child.url}
        className={reviewStateClass(child.review_state, 'item link')}
        activeClassName="selected"
        exact={
          settings.isMultilingual
            ? child.url === `/${toBackendLang(lang)}`
            : child.url === ''
        }
        // onClick={closeMenu}
      >
        {child.title}
      </NavLink>
      {child.items?.length > 0 && (
        <SubItems item={child} closeMenu={closeMenu} lang={lang} />
      )}
    </div>
  ));

  if (root) {
    return (
      <div className="sub">
        <div className="items">{content}</div>
      </div>
    );

    // return (
    //   <div className="sub">
    //     <ResponsiveMasonry
    //       className="items"
    //       columnsCountBreakPoints={{ 320: 2, 576: 3, 768: 3, 1024: 4, 1440: 5 }}
    //     >
    //       <Masonry gutter="1rem">{content}</Masonry>
    //     </ResponsiveMasonry>
    //   </div>
    // );
  }

  return (
    <div className="list">
      <div className="items">{content}</div>
    </div>
  );
};

export default SubItems;
